export default {
  name: 'Carousel',
  data () {
    return {
      items: [
        {
          src: 'static/Bandeau images/carousel-1.jpg',
        },
        /*
        {
          src: 'static/Bandeau images/3.png',
        },
        {
          src: 'static/Bandeau images/4.jpg',
        },
        */
        {
          src: 'static/Bandeau images/2.png',
        },
        {
          src: 'static/Bandeau images/6.png',
        }
      ],
        /*
      items: [
        {
          src: 'static/Bandeau images/resized/7.jpg',
        },
        {
          src: 'static/Bandeau images/resized/3.jpg',
        },
        {
          src: 'static/Bandeau images/resized/4.jpg',
        },
        {
          src: 'static/Bandeau images/resized/5.jpg',
        },
        {
          src: 'static/Bandeau images/resized/6.jpg',
        },
        {
          src: 'static/Bandeau images/resized/2.jpg',
        }
      ],
      */
    }
  },
  mounted: function() {
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
}



// WEBPACK FOOTER //
// ./src/views/global/carousel/carousel.component.js